module.exports = __webpack_public_path__ + "img/bg-type05-mask.18e5523a.png";